import React, { Component, Fragment } from 'react';
import FourCol from '../../containers/fourCol';
import ThreeQuarter from '../../containers/threeQuarter';
import Row from '../../containers/row';
import TopRow from "./topRow";
import FlexText from "../../flexText";
import ReactHtmlParser from 'react-html-parser';
import NewsItems from '../../newsItems';
import Profiles from '../../profiles';
import QuickLinks from '../../rows/quickLinks/quickLinks';
import InfoBand from '../../rows/infoBand/infoBand';
import Accordion from '../../accordion/accordion';
import ImageSlider from '../../imageSlider';

class ColMaker extends Component {
  renderRow(data, rightCol = false) {
    switch(data.bundle) {
      case 'accordion':
        return (
          <div className="accordion" style={{marginBottom:"1em"}}>
            <Accordion config={data} />
          </div>
        );
      case 'quick_links':
        return (
          <ul className="noDot" style={{ listStyle:"none",margin:0,padding:0,borderTop:"8px solid rgb(221,221,221)"}}>
            <QuickLinks config={data} />
          </ul>
        );
      case 'infoband':
        return (
          <InfoBand config={data} />
        )
      case 'news_items':
        return (
          <NewsItems config={data} />
        )
      case 'personnel_profiles':
        return (
          <Profiles config={data} />
        )
      case 'slideshow':
        return (
          <div className="slideshow">
            <ImageSlider ulStyles={{padding:0,margin:0,overflow:"auto",}} slides={data.field_slides}
              arrowNav={{
                bottom:0,
                useArrow:true,
                right:"0px",
                arrowStyles: {
                  position:"absolute",
                  zIndex:"4444",
                  padding: "5px",
                },
              }} />
          </div>
        );
      case "body":
        // If right column, use image style based on width
        if (rightCol) {
          let imageStyle = 600;
          if (window.innerWidth >= 600 && window.innerWidth < 900) {
            imageStyle = 900; 
          }
          data.field_longtext_1 = data.field_longtext_1.replace('/styles/1200/public/', '/styles/' + imageStyle + '/public/');
        }
        return (
          <div>
            {typeof data.field_text_1 !=="undefined"?(
              <FlexText tag="h1" max="40" min="40" 
                styles={{
                  fontFamily: "Oswald", 
                  width:"100%",
                  display:"inline-block",
                  textTransform:"uppercase"
                }}>{ReactHtmlParser(data.field_text_1)}</FlexText>
            ):null}
            {typeof data.field_longtext_1 !== "undefined"
              ?<Row padding="24px auto">
                  {ReactHtmlParser(data.field_longtext_1)}
                </Row>                      
              :null}
          </div>
        );
      default: return(<p>Undefined bundle type colmaker renderRow: {data.bundle}</p>);
    }
  }

  renderRows(rightCol = false) {
    return this.props.rows.map((data, i) => (
      <Fragment key={i}>
        {this.renderRow(data, rightCol)}
      </Fragment>
    ));
  }

  renderHeader() {
    return(
      <Fragment>
        {this.props.header!==null?(    
          <TopRow 
            bundle={this.props.header.bundle} 
            media={this.props.header.field_image} 
            type={this.props.header.field_header_type}
            links={this.props.header.field_links_1}
            title={this.props.header.title}
            slides={this.props.header.field_slide}
            style={this.props.style}
            token={this.props.token}
          />):null}
      </Fragment>
    );
  }  

  render() {
    if (this.props.col === "left") {
      switch (this.props.layout) {
        case "two_column":
          return ( 
            <ThreeQuarter>
            {this.renderHeader()}
            {this.renderRows()}
            </ThreeQuarter>
          );
        case "two_column_full_head":
          return (
            <Fragment>
              {this.renderHeader()}
              <ThreeQuarter>
                {this.renderRows()}
              </ThreeQuarter>
            </Fragment>
          );
        case "full_width":
          return (
            <Fragment>
              {this.renderHeader()} 
              {this.renderRows()}
            </Fragment>
          );
        default: return(<p>{"Something Went Wrong "+this.props.field_page_layout}</p>);
      }
    } else {
      return(
        <FourCol className="rightcol"
          styles={{
            fontSize:"16px",
            lineHeight:"24px",
            maxWidth:window.innerWidth>899?"450px":"100vw",
            width:window.innerWidth>899?"25%":"100vw",
            display:"inline-block",
            float:"left",
            margin:"0",
          }}>
          {this.renderRows(true)}
        </FourCol>
      );
    }
  }
}

export default ColMaker;
